import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector, RootStateOrAny } from 'react-redux';
import { LoginState } from '../store/ducks/auth/types';

export default function RouterWrapp({
  component: Component,
  isPrivate,
  ...rest
}: any) {
  const { signed: logged } = useSelector<RootStateOrAny, LoginState>((state) => state.user);

  const signed = logged;
  if (!signed && isPrivate) {
    return <Redirect to="/" />;
  }
  return <Route {...rest} component={Component} />;
}
